export const errorMessages = {
  SERVICE_UNAVAILABLE: 'Сервіс тимчасово недоступний. Будь ласка, спробуйте ще раз пізніше.',
  DOCUMENT_FETCH_FAILED: 'На жаль, не вдалося отримати документи. Спробуйте ще раз.',
  SIGNATURE_DOCUMENT_SIGN_FAILED: 'На жаль не вдалося підписати документи, спробуйте ще раз',
  SIGNATURE_QR_CODE_TIME_OUT: 'Час сплинув. Спробуйте ще раз.',
  TEXT_ABOUT_INVALID_LINK: 'Це посилання більше не працює',
  QR_CODE_EXPIRE: 'Термін QR-коду вийшов. Спробуйте ще.',
  LEGAL_FUNCTIONALITY_IN_PROGRESS:
    'Функціонал для юридичних осіб в розробці. Невдовзі буде доступний.',
  FORM_IS_NOT_COMPLETED: 'Усі форми мають бути заповнені.',
  LEGAL_FUNCTIONALITY_IN_PROGRESS_RESIDENT:
    'Функціонал для юридичних осіб-нерезидентів в розробці. Невдовзі стане доступним.',
  FIRST_SIGN_MISSING: 'Позначте керівника або додайте розпорядника з правом першого підпису.',
  VISIT_BRANCH_REQUIRED:
    'Шановний клієнт, прохання звернутись до найближчої точки обслуговування для подання пакету документів!',
  VISIT_BRANCH_REQUIRED_EIGHTEEN:
    'Шановний клієнт, якщо вам менше 18 років, прохання звернутись до найближчої точки обслуговування для подання пакету документів!',
  INVALID_APPLICATION_NUMBER: 'Неправильно введений № заявки',
  APPLICATION_NUMBER_REQUIRED: 'Будь ласка, введіть № заявки',
  MUST_BE_CORRECT_APPLICATION_NUMBER: '№ заявки повинен містити літери a-f та цифри 0-9',
  MUST_BE_CORRECT_APPLICATION_NUMBER_FORMAT: 'Має бути формат xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
  MAX_LENGTH_APPLICATION_NUMBER: (length: string | number) =>
    `Недостатньо символів. Введено: ${length}, потрібно: 32 (без дефісів)`,
  ASSET_MANAGER_VERIFICATION: 'Вказані Вами розпорядники мають пройти верифікацію.',
  OPTION_REQUIRED: 'Будь ласка, оберіть опцію',
  FILE_TOO_LARGE: 'Розмір файлу не повинен перевищувати 15MB',
  INVALID_FILE_FORMAT:
    'Недопустимий формат файлу. Дозволені формати: jpg, jpeg, bmp, ppt, txt, docx, xlsx, pdf.',
  UNSUPPORTED_P7S_FILE:
    'Очікується файл в іншому форматі, проте отримано файл із розширенням .p7s, який є електронним підписом. Будь ласка, надайте файл в іншому форматі.',
  INVALID_FILE_PAIR:
    'Невірний тип файлу для підпису. Другим файлом має бути електронний підпис у форматі .p7s',
  ONLY_TWO_FILES_WITH_SIGN:
    'Можна завантажити лише 2 файли за один раз, і другий файл має бути лише файлом підпису (.p7s).',
  MISSING_DOCUMENTS_BEFORE_SIGNING:
    'Переконайтеся, що всі необхідні документи завантажені перед підписанням.',
  UNVERIFIED_DOCUMENTS_BEFORE_SIGNING:
    'Переконайтеся, що всі необхідні документи завантажені та верифіковані перед підписанням.',
  MISSING_DOCUMENTS_BEFORE_SENDING_TO_CLIENT:
    'Переконайтеся, що всі необхідні документи завантажені перед відправкою на підписання клієнту.',
  MISSING_DOCUMENTS_BEFORE_SENDING_FOR_CLIENT_SIGNATURE:
    'Переконайтеся, що всі необхідні документи завантажені перед відправкою на підписанням клієнту.',
  DOCUMENT_SIGNING_FAILED: 'На жаль, не вдалося підписати документи. Спробуйте ще раз.',
  DOCUMENT_SIGNING_REFUSED: 'Підпис було відкликано. Спробуйте підписати файли ще раз.',
  SIGNATURE_VERIFICATION_FAILED:
    'Неуспішна перевірка підпису. Перевірте валідність КЕП та спробуйте ще раз.',
  MISSING_DOCUMENTS_BEFORE_DOCUMENT_GENERATION:
    'Відсутні документи, що повинні були сформуватись автоматично. Перевірте чи заповнені всі форми.',
  FIELD_REQUIRED: 'Будь ласка, заповніть поле',
  FIELD_REQUIRED_SHORT: 'Заповніть поле',
  FIELD_NEED_ONLY_NUMER: 'ЄДРПОУ/РНОКПП повинен містити тільки цифри',
  COUNTERPARTY_CODE_LENGTH: 'Введіть 8 або 10 цифр',
  INVALID_INPUT_DATA: 'Перевірте правильність введених даних',
  YES_NO_REQUIRED: 'Будь ласка, оберіть "Так" або "Ні"',
  ANSWER_OPTION: 'Будь ласка, оберіть варіант відповіді',
  FILL_ALL_FIELDS: 'Будь ласка, заповніть всі необхідні поля',
  ADDITIONAL_INFORMATION_REQUIRED: 'Будь ласка, введіть додаткову інформацію',
  FILL_CLARIFYING_INFORMATION: 'Будь ласка, заповніть уточнюючу інформацію',
  FILL_OUT_THE_SURVEY_FORM: 'Надайте відповіді на запитання у додатку до Анкети-опитувальника',
  NUMBER_ATTEMPTS_EXHAUSTED:
    'Кількість спроб вичерпано, будь ласка, виконайте вхід ще раз через 15 хвилин!',
  BLOCKED_NUMBER_ATTEMPTS_EXHAUSTED: (timer: string) =>
    `Кількість спроб вичерпано, надсилання нового ОТП паролю заблоковано до ${timer}`,
  OTP_NOT_FOUND:
    'OTP не знайдено. Можливо він застарілий та його було видалено, або користувач створив новий OTP.',
  MAX_ATTEMPTS_OTP_VERIFY: 'Спроби вичерпано. Потрібна OTP верифіація.',
  CONSENT_PROCESSING_PERSONAL_DATA: 'Натисніть згоду про обробку персональних даних!',
  REGISTER_ENTRY_FORMAT: 'Запис у реєстрі має бути у форматі xxxxxxxx-xxxxx',
  GIIN_ENTRY_FORMAT:
    'Код GIIN має бути форматом хххххх.ххххх.хх.ххх та 0-9 та A-Z (верхній регістр)',
  ADDRESS_FIELDS: 'Поля адреси повинні бути заповнені',
  CODE_ADDRESS: 'Код адреси має починатись з UA',
  CORRECT_DATE_FORMAT: 'Введіть або оберіть дату',
  INVALID_IBAN: 'Невалідний IBAN',
  INCOMPLETE_IBAN: 'Введіть повний IBAN',
  PHONE_NUMBER_REQUIRED: 'Має бути вказано принаймні один номер телефону',
  INVALID_EMAIL_FORMAT: 'Неправильний формат електронної пошти',
  BLOCKED_EMAIL_DOMAIN: 'Некоректний формат електронної пошти',
  MISSING_SYMBOL: 'Включіть частину “@” в адресу електронної пошти',
  MISSING_SYMBOL_WITH_VALUE: (value: string) =>
    `Включіть частину "@" в адресу електронної пошти. У ${value} відсутній знак "@"`,
  EMAIL_ADDRESS_REQUIRED: 'Має бути вказано принаймні одну електронну адресу',
  MAX_LENGTH: (length: string | number) => `Поле має містити ${length} символів`,
  MAXIMUM_NUMBER_OF_CHARACTERS: (length: string | number) =>
    `Поле має містити не більше ${length} символів`,
  MINIMUM_NUMBER_OF_CHARACTERS: (length: string | number) =>
    `Поле має містити не менше ${length} символів`,
  LATIN_CHARACTERS_ONLY: 'Дозволені лише латинські літери',
  LATIN_NUMBERS_SYMBOLS_ONLY: 'Дозволені латинські літери, цифри та спецсимволи',
  ALLOWED_CHARS_SYMBOLS_ONLY:
    'Дозволені латинські літери та кирилиці, цифри та спецсимволи (- . /)',
  UPPER_CASE_LETTERS_ONLY: 'Дозволені латинські літери та кирилиці',
  UPPER_CASE_LETTERS_ONLY_OR: 'Дозволені великі латинські літери або кирилиці',
  UPPER_CASE_LATIN_AND_DIGITS: 'Дозволені великі латинські літери та цифри',
  UKR_CHARACTERS_ONLY: 'Дозволені лише кирилиці літери',
  LATIN_AND_UKR_CHARACTERS_ONLY: 'Дозволені лише латинські або кирилиці літери',
  MUST_BE_NUMBER: 'Введіть числове значення',
  MUST_BE_POSITIVE: 'Введіть додатне значення',
  MUST_BE_POSITIVE_OR_ZERO: 'Число має бути більше або рівне 0',
  MUST_BE_GREATER_THAN_ZERO: 'Число має бути більше 0',
  MUST_BE_LESS_OR_EQUAL_100: 'Число має бути менше або рівне 100',
  MUST_BE_INTEGER: 'Введіть ціле число',
  MUST_BE_WITHOUT_ZEROES: 'Введіть число без нулів на початку',
  MUST_HAVE_ONE_DECIMAL: 'Число має бути окрулене до цілих або десятих',
  MUST_HAVE_ONE_DECIMAL_NUMBER: (length: string | number) =>
    `Число має бути округлене до цілих або до ${length} знаків після крапки`,
  RADIO_OPTION_REQUIRED: 'Будь ласка, оберіть один із варіантів',
  AMOUNT_100_PERCENT: 'Сума має дорівнювати 100%',
  DUPLICATE_ACCOUNT_NUMBER: 'Такий номер рахунку вже існує',
  PASSPORT_EXPIRY_TOO_LONG: 'Строк дії паспорта не має бути більше ніж 10 років',
  PASSPORT_EXPIRY_TOO_SHORT: 'Строк дії паспорта має бути менше ніж 10 років',
  NO_DATA_FOUND: 'Даних не знайдено. Спробуйте змінити параметри пошуку',
  ASSET_MANAGER_UNIQUE_EMAIL: 'Електронна адреса має бути унікальною для кожного розпорядника',
  UNIQUE_EMAIL: 'Електронна адреса має бути унікальною',
  UNIQUE_IDENTIFICATION_NUMBER:
    'Розпорядник із таким РНОКПП / Номером платника вже існує. Видаліть дублікат для продовження',
  NO_KEP_FILES_FOUND:
    'Деякі файли підписані не КЕП, будь ласка перепідпишіть файли використовуючи КЕП.',
  NO_KEP_FILE_FOUND: 'Файл підписаний не КЕП, будь ласка перепідпишіть файл використовуючи КЕП.',
  NO_FILES_TO_SIGN: 'Файли для підпису відсутні.',
  PEP_END_AFTER_START_DATE:
    'Дата початку виконання публічних функцій має бути раніше за дату припинення іх виконання',
  AT_LEAST_ONE_SELECTED: 'Оберіть хоча б одну опцію',
  TWO_UPPER_CASE_UKRAINIAN_LETTERS: 'Серія документа має містити 2 великі літери кирилиці',
  TWO_LATIN_LETTERS: 'Серія документа має містити 2 великі літери латиниці',
  MAX_DIGITS_IN_DOC: (length: string | number) => `Номер документа має містити ${length} цифр`,
  AUTHORITY_ONLY_LETTERS: 'Назва органу має містити лише літери',
  AUTHORITY_ONLY_NUMBERS: 'Назва органу має містити 4 цифри',
  POSTAL_CODE_ONLY_NUMBERS: 'Індекс має містити 5 цифри',
  ONLY_ONE_SELECTED: 'Оберіть тільки 1 варіант',
  ONLY_TEXT: 'Поле має містити лише літери',
  DOCUMENT_TWO_CYRILLIC_LETTERS: 'Серія документа має містити 2 літери',
  DOCUMENT_TWO_LATIN_LETTERS: 'Серія документа має містити 2 літери латиниці',
  DOCUMENT_SIX_DIGITS: 'Номер документа має містити 6 цифр',
  DOCUMENT_NINE_DIGITS: 'Номер документа має містити 9 цифр',
  DOCUMENT_AUTHORITY_LETTERS: 'Назва органу має містити літери',
  DOCUMENT_AUTHORITY_FOUR_DIGITS: 'Назва органу має містити 4 цифри',
  DOCUMENTS_HAVE_NOT_ARRIVED:
    'На жаль, Дія не надала нам обраних Вами документів для ідентифікації. Будь ласка, спробуйте ще раз пройти верифікацію, обравши документ "Паспорт громадянина України у вигляді ID-картки", або "Закордонний паспорт громадянина України"',
  MAX_LENGTH_OF_CHARACTERS: (length: string | number) => `Максимум ${length} знаки після крапки`,
  USE_COMMA: 'Використовуйте крапку як роздільник, замість коми',
  SOURCES_OF_FUNDS: 'Оберіть джерела надходження коштів та цінностей',
  FIELD_OTP: 'Неправильно введений OTP',
  CHOOSE_SERVICE: 'Оберіть послуги, які плануєте отримувати',
  AT_LEAST_ONE_FROM_LIST: 'Будь ласка, оберіть хоча б один варіант зі списку',
  INVALID_DATE: 'Введіть актуальну дату',
  INVALID_IDENTIFICATION_NUMBER: 'Вкажіть коректний ідентифікаційний номер',
  INVALID_SIGNATURE:
    'Кваліфікований електронний підпис документа є недійсним або пошкодженим. Будь ласка, перевірте КЕП та спробуйте ще раз.',
  DATA_DOES_NOT_MATCH:
    'Підпис документа є дійсним, але ідентифікаційні дані у документі не відповідають даним заявки. Будь ласка, спробуйте ще раз.',
  CHANGE_MANAGER_DATA: 'Змінювати дані керівника при оновленні даних розпорядників заборонено',
  APPLICATION_IS_EXPIRED:
    'Це персональне посилання вже було використано, тому повторно перейти за ним неможливо. Будь ласка, розпочніть процес заново.',
  SERVICE_UNAVAILABLE_TRY_AGAIN:
    'За введеними даними інформацію не знайдено. Перевірте та спробуйте ще.',
  ONLY_ONE_PERSON:
    'Для обраної послуги, продукту(операції) необхідно зазначити хоча б одну контактну особу',
  REGISTRATION_CODE_ADDRESS: 'Будь ласка, заповніть адресу місця реєстрації',
  PERMANENT_CODE_ADDRESS: 'Будь ласка, заповніть адресу фактичного місця проживання',
  TEMPLATE_NOT_FOUND: 'Шаблон не знайдено',
  EMPTY_OWNERS: 'Необхідно додати власника або зазначити їх відсутність.',
  INVALID_URL_FORMAT: 'Невалідний формат. Посилання має починатись з https:// або http://',
  EMPTY_STOCK_URL: 'Вкажіть посилання на біржу',
  MAX_URL_LENGTH: 'Посилання занадто довге. Максимальна кількість символів — 500',
  INTEGER_GRATER_THAN_ZERO: 'Число має бути ціле та більше 0',
  INTEGER_OR_FLOAT: (length: number) => `Тільки цифри, до ${length} знаків після крапки`,
  MORE_THEN_PERCENT_SHARES: (length: number) =>
    `Акціонери з часткою понад ${length}% мають бути зазначені окремою карткою як ФО або ЮО.`,
  AT_LEAST_ONE_RANGE: 'Вкажіть хоча б один діапазон — для юридичних або фізичних осіб.',
  MUST_BE_EQUAL_100: 'Число має бути рівне 100',
  MUST_BE_BENEFICIARY: 'Особа має бути КБВ',
  EMPTY_LEGAL_OWNERS:
    'Необхідно додати власника або зазначити відсутність фізичних осіб, які мають вирішальний вплив на управління.',
  REQUIRED_IS_FORBIDEN_COUNTRY:
    'Оберіть відповідь на питання щодо наявності громадян/резидентів РФ або РБ.',
  REQUIRED_FORBIDEN_COUNTRY_OWNER:
    'Вкажіть хоча б одну особу — громадянина або резидента РФ чи РБ.',
  OWNER_UNIQUE_IDENTIFICATION_NUMBER:
    'Учасник з таким кодом вже доданий у структуру власності. Оберіть його зі списку “Додати існуючого”.',
  OWNER_TYPE_REQUIRED: 'Оберіть тип власника',
  ANSWER_REQUIRED: 'Оберіть відповідь',
};

export const errorMessagesRegistration = {
  MAX_LENGTH_LOGIN: 'Максимальна довжина логіна має бути 20 символів',
  MIN_LENGTH_LOGIN: 'Мінімальна кількість символів 5',
  INCORRECT_LOGIN_FORMAT: 'Некоректний формат логіну',
  MIN_LENGTH_PASSWORD: 'Пароль повинен містити мінімум 8 символів',
  PASSWORD_UPPERCASE: 'Пароль повинен включати великі літери (A-Z)',
  PASSWORD_LOWERCASE: 'Пароль повинен включати малі літери (a-z)',
  PASSWORD_DIGITS: 'Пароль повинен включати цифри (0-9)',
  PASSWORD_SPECIAL_CHARS: 'Пароль повинен включати спеціальні символи (наприклад, !, @, #, $, %)',
  PASSWORD_TRIVIAL_PATTERNS: 'Пароль занадто простий або містить тривіальні послідовності',
  PASSWORD_INVISIBLE_SPACES: 'Пароль не може містити пробіли або невидимі символи',
  PASSWORDS_MUST_MATCH: 'Паролі повинні співпадати',
};

export const errorMessagesSignIn = {
  INVALID: 'Неправильно введені дані',
  INVALID_CREDENTIALS: 'Введено невірний логін або пароль',
  NOT_IN_GROUP: 'Користувач не входить до вказаної групи',
  LOGIN_FAILED: 'Не вдалося увійти. Перевірте логін і пароль',
  LOGIN_FAILED_REQUIRED: 'Будь ласка, заповніть поле логін',
};

export const allErrorMessages = {
  ...errorMessagesSignIn,
  ...errorMessagesRegistration,
  ...errorMessages,
};
